import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS, apiS_fileDownload, apiS_ignore1298 } from "./api-base";
import { getESGReqHeader } from "./tool-service";

export const queryEvaluationByPlanSn = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010309"),
    ReqBody: reqBody,
  };
  return await apiS_ignore1298({ url: `/${getTxtIdMapperPath("F1010309")}`, method: "post", data: ReqBody });
};

// 重大性評估範本清單查詢
export const queryEvaluationTemplate = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1010310"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1010310")}`, method: "post", data: ReqBody });
};

//重大性評估範本明細查詢
export const queryEvaluationTemplateDetail = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031001"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031001")}`, method: "post", data: ReqBody });
};

//評估標準清單查詢
export const queryEvaluateSetting = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031005"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031005")}`, method: "post", data: ReqBody });
};

//評估標準明細查詢
export const queryEvaluateDetailSetting = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031006"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031006")}`, method: "post", data: ReqBody });
};

// 評估標準新增
export const createEvaluateSetting = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031007"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031007")}`, method: "post", data: ReqBody });
};

export const updateEvaluateSetting = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031008"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031008")}`, method: "post", data: ReqBody });
};

// 排放源型式清單
export const queryEvaluateItems = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031009"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031009")}`, method: "post", data: ReqBody });
};

export const F101031002Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031002"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031002", true)}`, method: "post", data: ReqBody });
};

//重大性評估範本明細新增
export const createEvaluateTemplate = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031002"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031002")}`, method: "post", data: ReqBody });
};

export const F101031003Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031003"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031003", true)}`, method: "post", data: ReqBody });
};

//重大性評估範本明細編輯
export const updateEvaluateTemplate = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031003"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031003")}`, method: "post", data: ReqBody });
};

//重大性評估更新
export const updateImportanceEvaluation = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031004"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031004")}`, method: "post", data: ReqBody });
};

//重大性評估範本複製
export const copyImportanceEvaluationTemp = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031010"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031010")}`, method: "post", data: ReqBody });
};

export const deleteEvaluationTemplate = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F101031011"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F101031011")}`, method: "post", data: ReqBody });
};
